import axios from 'axios';
import React, { useState } from 'react';

// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { BsFacebook, BsGoogle } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { globalEnv } from '../../../config/baseConfig';
import { LoginAuthAction } from '../../../redux/actions/authAction';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { signInWithFacebook, signInWithGoogle } from './firebase';
import { stateNotificationsEnum } from '../notification';

function SocialLoginComponent({
	isLoading,
	setIsLoading
}: {
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;
}) {
	const [response, setResponse] = useState<any>('');

	const facebookAuthCallback = (response: any) => {
		if (response.tokenId) {
			setResponse(response);
			setIsLoading(true);
			facebookLoginSubmit.mutate();
		} else {
			setIsLoading(false);
		}
	};

	const googleAuthCallback = (response: any) => {
		if (response.tokenId) {
			setResponse(response);
			setIsLoading(true);
			googleLoginSubmit.mutate();
		} else {
			setIsLoading(false);
		}
	};

	const facebookLoginReq = async () => {
		const params = new URLSearchParams();
		params.append('tokenId', response.tokenId);
		params.append('deviceId', '000000');
		const { data: res } = await axios.post(
			globalEnv.BASE_URL + '/user/facebook-login-editor/',
			params
		);
		return res;
	};

	const googleLoginReq = async () => {
		const params = new URLSearchParams();
		params.append('tokenId', response.tokenId);
		params.append('deviceId', '000000');
		const { data: res } = await axios.post(
			globalEnv.BASE_URL + '/user/google-login-editor/',
			params
		);
		return res;
	};

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const facebookLoginSubmit = useMutation(facebookLoginReq, {
		onSuccess: (data) => {
			dispatch(LoginAuthAction(data));
			navigate(`../home/documents`);
		},
		onError: (error) => {
			setIsLoading(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: 'Unable to login.'
				})
			);
		}
	});

	const googleLoginSubmit = useMutation(googleLoginReq, {
		onSuccess: (data) => {
			dispatch(LoginAuthAction(data));
			navigate(`../home/documents`);
		},
		onError: (error) => {
			setIsLoading(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: 'Unable to login.'
				})
			);
		}
	});

	const firebaseFacebookLogin = () => {
		dispatch(signInWithFacebook('00000', facebookAuthCallback));
	};

	const firebaseGoogleLogin = () => {
		dispatch(signInWithGoogle('00000', googleAuthCallback));
	};

	return (
		<div>
			{!isLoading ? (
				<div className="flex flex-row space-x-3">
					<BsFacebook
						className="cursor-pointer"
						onClick={firebaseFacebookLogin}
						size={25}
					/>
					<BsGoogle
						className="cursor-pointer"
						onClick={firebaseGoogleLogin}
						size={25}
					/>
				</div>
			) : (
				<div className="flex flex-row space-x-3">
					<BsFacebook className="fill-gray-500 " size={25} />
					<BsGoogle className="fill-gray-500" size={25} />
				</div>
			)}
		</div>
	);
}

export default SocialLoginComponent;
